import { DataProcessor } from './DataProcessor';
import { Calculator } from './Calculator';

class RezultataiClass {
    constructor(data = {}, setter) {
        this.nerodyti = data.nerodyti;
        this.dataProcessor = new DataProcessor(data.nerodyti);
        this.calculator = new Calculator(data.nerodyti);
    }

    // Data Processing Methods
    visiAtsakymaiPagalKasPilde(atsakymai) {
        return this.dataProcessor.visiAtsakymaiPagalKasPilde(atsakymai);
    }

    atsakymaiGrafikui(val) {
        return this.dataProcessor.atsakymaiGrafikui(val);
    }

    formTipaiCsv(val) {
        return this.dataProcessor.formTipaiCsv(val);
    }

    beMetu(val) {
        return this.dataProcessor.beMetu(val);
    }

    visiAtsakymaiPagalImonesIrDatas(atsakymai) {
        return this.dataProcessor.visiAtsakymaiPagalImonesIrDatas(atsakymai);
    }

    datomAtsakymai(info) {
        return this.dataProcessor.datomAtsakymai(info);
    }

    datomParuostiAtsakymai(info) {
        return this.dataProcessor.datomParuostiAtsakymai(info);
    }

    // Calculator Methods
    visiAts(tipai, info) {
        return this.calculator.visiAts(tipai, info);
    }

    klausimuAtsakymai(atsakymai, tipai) {
        return this.calculator.klausimuAtsakymai(atsakymai, tipai);
    }

    bendrasAtsakymas(atsakymai, tipai) {
        return this.calculator.bendrasAtsakymas(atsakymai, tipai);
    }

    // Page Management Methods
    puslapiaiIsTipu(tipai) {
        return this.dataProcessor.puslapiaiIsTipu(tipai);
    }

    tipaiBeNereikalinguPuslapiu(tipai) {
        return this.dataProcessor.tipaiBeNereikalinguPuslapiu(tipai);
    }

    puslapiuPavadinimai(tipai) {
        return this.dataProcessor.puslapiuPavadinimai(tipai);
    }

    // Additional Helper Methods
    addToNerodytiPages(x) {
        if (!this.nerodyti.pages) {
            this.nerodyti.pages = [];
        }
        this.nerodyti.pages.push(x);
    }
}

export default RezultataiClass;
